var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath54Dark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 164,
    viewBox: "0 0 171 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.94 101.225C122.562 101.997 122.137 102.721 121.616 103.447C117.974 109.2 112.815 114.003 106.71 117.4C100.466 120.89 93.2248 122.929 85.4173 122.929H85.3233C77.5627 122.929 70.3234 120.935 64.0752 117.445C57.8313 114.048 52.6255 109.155 48.9365 103.31C48.5562 102.721 48.2251 102.177 47.894 101.587C44.583 95.7888 42.7353 89.1741 42.7353 82.1504C42.7353 67.0638 51.3012 53.8794 64.0752 46.8556C70.3234 43.3682 77.5627 41.372 85.3233 41.372H85.4173C93.2248 41.372 100.466 43.4132 106.71 46.9006C119.392 53.9694 127.909 67.1088 127.909 82.1504C127.909 89.0371 126.113 95.5168 122.94 101.225ZM159.092 41.372L158.904 41.057C152.705 30.9079 144.33 22.2069 134.345 15.5022C132.312 14.0521 130.182 12.784 128.003 11.6058C115.513 4.62909 100.844 0.64064 85.3233 0.595642C69.8022 0.595642 55.2252 4.6291 42.7353 11.5608C30.3393 18.3576 19.9278 28.1426 12.4514 39.8789C12.1694 40.3759 11.8362 40.875 11.5542 41.372C11.3641 41.689 11.1761 42.0081 10.986 42.3251C10.7959 42.6422 10.6058 42.9592 10.4178 43.2762C3.88764 54.8305 0.149414 68.0599 0.149414 82.1504V163.705H42.7353V152.74C55.2252 159.672 69.8022 163.705 85.3233 163.705C100.748 163.66 115.513 159.672 128.003 152.695C130.182 151.517 132.312 150.249 134.345 148.798C144.426 142.049 152.895 133.213 159.092 122.929C159.139 122.884 159.139 122.837 159.188 122.792C166.381 110.83 170.497 96.967 170.497 82.1504C170.497 67.2888 166.381 53.3803 159.092 41.372Z",
    fill: "url(#paint0_linear_2353_1188)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2353_1188",
    x1: 170,
    y1: 182,
    x2: 46,
    y2: -20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2358A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E1A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath54Dark);
export default __webpack_public_path__ + "static/media/path54Dark.51dac17626be6162ef58ccc5625dc33c.svg";
export { ForwardRef as ReactComponent };